import { Box, SxProps, Theme } from '@mui/material';
import { parseInlineStyleString } from '../../Utils/parseInlineStyleString';
import {
  LOGO_ASSET_DESKTOP_MAX_HEIGHT_PX,
  LOGO_ASSET_DESKTOP_MAX_WIDTH_PX,
  LOGO_ASSET_MOBILE_MAX_HEIGHT_PX,
  LOGO_ASSET_MOBILE_MAX_WIDTH_PX,
  LOGO_ASSET_MOBILE_RESERVED_HEIGHT_PX,
  LOGO_ASSET_TITLE_GAP_PX,
} from './consts';

interface HeroCarouselLogoAssetProps {
  src?: string;
  alt?: string;
  cssClass?: string;
  inlineStyle?: string;
  reserveMobileLogoSpace?: boolean;
}

const logoImageSx = {
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  display: 'block',
} as const;

const buildLogoImageSx = (
  maxWidthPx: number,
  maxHeightPx: number,
  inlineStyle?: string,
): SxProps<Theme> => ({
  ...logoImageSx,
  maxWidth: `${maxWidthPx}px`,
  maxHeight: `${maxHeightPx}px`,
  ...(inlineStyle ? parseInlineStyleString(inlineStyle) : {}),
});

export const HeroCarouselLogoAsset = ({
  src,
  alt = '',
  cssClass,
  inlineStyle,
  reserveMobileLogoSpace = false,
}: HeroCarouselLogoAssetProps) => {
  const hasLogo = Boolean(src);

  return (
    <>
      {reserveMobileLogoSpace && hasLogo && (
        <Box
          sx={{
            display: { xs: 'flex', sm: 'none' },
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: `${LOGO_ASSET_MOBILE_RESERVED_HEIGHT_PX}px`,
            mb: `${LOGO_ASSET_TITLE_GAP_PX}px`,
          }}
        >
          {hasLogo && (
            <Box
              component="img"
              src={src}
              alt={alt}
              className={cssClass}
              sx={buildLogoImageSx(
                LOGO_ASSET_MOBILE_MAX_WIDTH_PX,
                LOGO_ASSET_MOBILE_MAX_HEIGHT_PX,
                inlineStyle,
              )}
            />
          )}
        </Box>
      )}

      {hasLogo && (
        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            mb: { sm: 2, md: 3 },
          }}
        >
          <Box
            component="img"
            src={src}
            alt={alt}
            className={cssClass}
            sx={buildLogoImageSx(
              LOGO_ASSET_DESKTOP_MAX_WIDTH_PX,
              LOGO_ASSET_DESKTOP_MAX_HEIGHT_PX,
              inlineStyle,
            )}
          />
        </Box>
      )}
    </>
  );
};
